import React from "react";
import { DateRangeChartProps } from "../types";
import { DateRangeChartComponent } from "../components";
import { generateDataCategories, generateXAxisData, getEmissionType } from "../utils";

export const RenewableNonRenewableChart = ({
  dateRangeType,
  subTabName,
  currentMainTab,
  ...props
}: DateRangeChartProps) => {
  const generateChartData = (data: any[], emissionType: string) =>
    generateDataCategories(data, emissionType, "renewableNonRenewable");

  const generateSeriesData = (chartData: any, sortedCategories: string[]) =>
    generateXAxisData(
      chartData,
      sortedCategories,
      dateRangeType,
      getEmissionType(
        subTabName === "location" || subTabName === "market",
        currentMainTab === "Consumption",
        subTabName
      )
    );

  return (
    <DateRangeChartComponent
      {...props}
      dateRangeType={dateRangeType}
      subTabName={subTabName}
      currentMainTab={currentMainTab}
      chartType="renewable-non-renewable"
      dataKey="renewableNonRenewable"
      generateChartData={generateChartData}
      generateSeriesData={generateSeriesData}
    />
  );
};
